import { type RenderMark } from '@contentful/rich-text-react-renderer'
import React from 'react'

export const italicResponsive: RenderMark[string] = (text) => (
  <span className="text-[3.125rem]/[3.125rem] laptop:text-[3.75rem]/[3.4375rem] laptopL:text-[4.375rem]/[4.0625rem]">
    {text}
  </span>
)
